import * as React from 'react';

import BreadCrumbs from '@src/components/BreadCrumbs';

import * as styles from './articleHero.module.scss';

export interface ArticleHeroProps {
  heading: string;
  subheading: string;
  image?: Image;
  slug: string;
  showBreadcrumbs: string;
}

const ArticleHero = ({
  heading,
  subheading,
  image,
  slug,
  showBreadcrumbs,
}: ArticleHeroProps) => (
  <section className={styles.wrapper}>
    {showBreadcrumbs === 'Yes' && <BreadCrumbs slug={slug} title={heading} />}

    <div className={styles.contentWrapper}>
      <div className={styles.content}>
        <div className={styles.heroText}>
          <h1 className={styles.heading}>{heading}</h1>
          {subheading && <h2 className={styles.subHeading}>{subheading}</h2>}
        </div>
        {image && (
          <div className={styles.heroImgBg}>
            <img
              className={styles.heroImg}
              src={image.url}
              alt={image.alt || ''}
            />
          </div>
        )}
      </div>
    </div>
  </section>
);

export default ArticleHero;
